module.exports = __webpack_public_path__ + "img/icon-iphone.24778234.svg";